export default __webpack_public_path__ + "static/media/pantry1-afterC-480w.a3070f04.png";